<template>
  <div>
    <div class="q_inter_top q_center">
      <p class="q_text_xxl q_bold q_color_white" style="letter-spacing: 0.6vw;">{{ user.integral }}</p>
      <p class="q_text_m q_color_white q_mar_t10px">我的积分</p>
    </div>
    <div class="q_mar_t30px q_pad_lr15px">
      <div class="q_mar_b15px">
        <span class="q_text_l q_bold">热门兑换</span>
        <span class="q_color_gray q_text_s q_flo_right q_mar_t3px" @click="goToExchange()">查看更多</span>
      </div>
    </div>
    <div class="q_mar_l15px q_mar_r1px">
      <div class="q_store" @click="goToExchangdea(item.id)" v-for="item in hotGoodsList" :key="item.id">
        <van-image fit="cover" :src="convertImg(item.pic)"/>
        <div class="q_text_m q_bold q_moit1 q_mar_t5px">{{ item.name }}</div>
        <div class="q_text_m q_bold q_color_red q_mar_t5px">{{ item.integral }}积分</div>
      </div>
      <!--			<div class="q_store">-->
      <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
      <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
      <!--				<div class="q_text_m q_bold q_color_red q_mar_t5px">32积分</div>-->
      <!--			</div>-->
      <!--			<div class="q_store">-->
      <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
      <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
      <!--				<div class="q_text_m q_bold q_color_red q_mar_t5px">32积分</div>-->
      <!--			</div>-->
    </div>
    <div class="q_mar_t30px q_pad_lr15px">
      <div class="q_mar_b15px">
        <span class="q_text_l q_bold">积分记录</span>
        <span class="q_color_gray q_text_s q_flo_right q_mar_t3px" @click="goToIntegral()">查看更多</span>
      </div>
      <div class="q_center" style="    margin-top: 5vh;
    margin-bottom: 10vh;" v-if="integralList.length == 0">
        <img src="@/assets/image/none.png" style="width: 26vw;"/>
        <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
      </div>
      <div class="q_vertical_left q_inter q_mar_b15px q_bor_bottom q_pad_tb5px" v-for="item in integralList"
           :key="item.id">
        <van-image v-if="item.type=='1'&&item.isSign!='1'&&item.isSign!='2'" fit="cover"
                   :src="require('@/assets/image/icon_j.png')"/>
        <van-image v-if="item.type=='0'&&item.isSign!='1'&&item.isSign!='2'" fit="cover"
                   :src="require('@/assets/image/icon_j1.png')"/>
        <van-image v-if="item.isSign=='1'" fit="cover" :src="require('@/assets/image/icon_j2.png')"/>
        <van-image v-if="item.isSign=='2'" fit="cover" :src="require('@/assets/image/icon_j3.png')"/>
        <div class="q_inlineblock q_mar_l10px q_inter_cen">
          <p v-if="item.isSign=='1'" class="q_mar_b10px q_text_m q_moit1">每日签到</p>
          <p v-if="item.isSign=='2'" class="q_mar_b10px q_text_m q_moit1">爱心捐款</p>
          <p v-if="item.isSign!='1'&&item.isSign!='2'" class="q_mar_b10px q_text_m q_moit1">{{ item.activityName }}</p>
          <p class="q_mar_b10px q_text_s q_color_gray">{{ item.createTime }}</p>
        </div>
        <div v-if="item.type=='1'" class="q_inlineblock q_text_m q_bold q_inter_ri">-{{ item.score }}积分</div>
        <div v-if="item.type=='0'" class="q_inlineblock q_text_m q_bold q_color_yellow q_inter_ri">+{{ item.score }}积分
        </div>
      </div>
      <!--			<div class="q_vertical_left q_inter q_mar_b15px q_bor_bottom q_pad_tb5px">-->
      <!--				<van-image fit="cover" :src="require('../../assets/image/icon_j1.png')" />-->
      <!--				<div class="q_inlineblock q_mar_l10px q_inter_cen">-->
      <!--					<p class="q_mar_b10px q_text_m q_moit1">参加活动</p>-->
      <!--					<p class="q_mar_b10px q_text_s q_color_gray">2022-04-18</p>-->
      <!--				</div>-->
      <!--				<div class="q_inlineblock q_text_m q_bold q_color_yellow q_inter_ri">+3000积分</div>-->
      <!--			</div>-->

    </div>
  </div>
</template>

<script>
import {listHotGoods} from "@/api/goods";
import {listIntegral} from "@/api/integral";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Myintegral',
  props: {
    msg: String
  },
  data() {
    return {
      user: {},
      hotGoodsList: [],
      integralList: [],
      pageParam: {
        pageNum: 0,
        pageSize: 10,
        userId: ''
      }
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading()
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
    }).then(() => {
      this.init()
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    /**
     * 初始话
     */
    init() {
      this.$modal.loading()
      //获取热门兑换商品
      listHotGoods().then(res => {
        this.hotGoodsList = res.rows
      }).then(() => {
        //获取我的积分记录
        this.pageParam.userId = this.user.id
        listIntegral(this.pageParam).then(res => {
          this.integralList = res.rows
        })
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToIntegral() {
      this.$router.push({
        path: '/mine/Integral'
      });
    },
    goToExchange() {
      this.$router.push({
        path: '/home/Exchange'
      });
    },
    goToExchangdea(id) {
      this.$router.push({
        path: '/home/Exchangdea', query: {id: id}
      });
    },
  }
}
</script>
<style scoped="scoped">
.q_store {
  display: inline-block;
  width: 33.33%;
  margin-bottom: 15px;
}

.q_store >>> .van-image__img {
  width: 105.5px;
  height: 105.5px;
  border-radius: 5px;
}

.q_inter_top {
  width: 100%;
  height: 150px;
  background: url(../../assets/image/integral.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 54px;
}

.q_inter .van-image {
  width: 35px;
  height: 35px;
}

.q_inter_cen {
  width: 220px;
}

.q_inter_cen .q_moit1 {
  width: 220px;
}

.q_inter_ri {
  width: 80px;
  text-align: right;
}
</style>
